import { render } from "./ApartmentsInfobar.vue?vue&type=template&id=4be18b6f"
import script from "./ApartmentsInfobar.vue?vue&type=script&lang=js"
export * from "./ApartmentsInfobar.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__